// extracted by mini-css-extract-plugin
export default {"descriptionQuill":"EventCreateUpdateFields_descriptionQuill__clGpv"};